var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.css(), _vm.css('', _vm.type)]},[_c('AtomGraphic',{key:_vm.graphicName,class:_vm.css('logo'),attrs:{"name":_vm.graphicName,"size":16}}),_vm._v(" "+_vm._s(_vm.content)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }